import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import { ValidationProvider, extend } from "vee-validate";
import "./vee-validate";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import VueTextareaAutosize from "vue-textarea-autosize";
import Vuex from "vuex";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-119548458-1" }
});

Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));

extend("datecheck", value => {
  if (value.substring(0, 2) !== "20") {
    return "Must be an actual date";
  }
  value = new Date(value);
  value = value.toISOString().split("T")[0];
  var today = new Date();
  today.setDate(today.getDate() - 1);
  today = today.toISOString().split("T")[0];

  return true;
});

// Register it globally
Vue.component("ValidationProvider", ValidationProvider);

Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.use(VueTextareaAutosize);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
